import type { Document } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

function isRichTextDocument(value: unknown): value is Document {
  return (
    typeof value === 'object' &&
    value != null &&
    'nodeType' in value &&
    (value as Document).nodeType === 'document'
  );
}

/** Normalizes textTeaserCard text to HTML for TeaserCard `content` (string). */
export function normalizeTeaserCardText(text: unknown): string {
  if (typeof text === 'string') {
    return text;
  }

  if (isRichTextDocument(text)) {
    return documentToHtmlString(text) ?? '';
  }

  return '';
}
